// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,json_types=true"
// @generated from file forms/v1/poll.proto (package forms.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_common_v1_annotations } from "../../common/v1/annotations_pb";
import type { PaginationArguments, PaginationArgumentsJson, PaginationPageInfo, PaginationPageInfoJson } from "../../common/v1/pagination_pb";
import { file_common_v1_pagination } from "../../common/v1/pagination_pb";
import type { Creator, CreatorJson } from "../../common/v1/types_pb";
import { file_common_v1_types } from "../../common/v1/types_pb";
import type { FieldMask, FieldMaskJson, Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_field_mask, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file forms/v1/poll.proto.
 */
export const file_forms_v1_poll: GenFile =
	/*@__PURE__*/
	fileDesc(
		"ChNmb3Jtcy92MS9wb2xsLnByb3RvEghmb3Jtcy52MSJcCgZXaW5kb3cSKQoFc3RhcnQYASABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEicKA2VuZBgCIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXAiLAoFSW1hZ2USEQoJaW1hZ2VfdXJsGAEgASgJEhAKCGFsdF90ZXh0GAIgASgJImsKClBvbGxBbnN3ZXISDQoFdmFsdWUYASABKAkSFQoNcHJpbWFyeV9sYWJlbBgCIAEoCRIXCg9zZWNvbmRhcnlfbGFiZWwYAyABKAkSHgoFaW1hZ2UYBCABKAsyDy5mb3Jtcy52MS5JbWFnZSK8AQoIUXVlc3Rpb24SCgoCaWQYASABKAkSDwoHcG9sbF9pZBgCIAEoCRIQCghxdWVzdGlvbhgDIAEoCRIMCgRuYW1lGAYgASgJEhMKC2Rlc2NyaXB0aW9uGAQgASgJEh0KEGFsdGVybmF0aXZlX3RleHQYByABKAlIAIgBARIqCgxwb2xsX2Fuc3dlcnMYBSADKAsyFC5mb3Jtcy52MS5Qb2xsQW5zd2VyQhMKEV9hbHRlcm5hdGl2ZV90ZXh0IrgGCgRQb2xsEgoKAmlkGAEgASgJEg8KB3ZlcnNpb24YAiABKAkSDgoGb3JnX2lkGAMgASgJEhQKDHdvcmtzcGFjZV9pZBgEIAEoCRINCgV0aXRsZRgFIAEoCRITCgtkZXNjcmlwdGlvbhgGIAEoCRINCgVzdGF0ZRgYIAEoCRIjCgdjcmVhdG9yGBcgASgLMhIuY29tbW9uLnYxLkNyZWF0b3ISDwoHaGVhZGluZxgLIAEoCRITCgtoZWxwZXJfdGV4dBgRIAEoCRIbChNyZXN1bHRzX2hlbHBlcl90ZXh0GBIgASgJEhgKEHNraXBfYnV0dG9uX3RleHQYEyABKAkSGgoSc3VibWl0X2J1dHRvbl90ZXh0GBQgASgJEhwKFGNvbXBsZXRlX2J1dHRvbl90ZXh0GBUgASgJEhsKE3Jlc3RhcnRfYnV0dG9uX3RleHQYFiABKAkSGQoReW91cl9hbnN3ZXJfbGFiZWwYDCABKAkSHwoXc2hvd19wcmVfdm90ZV9jb3VudGRvd24YDSABKAgSFwoPcHJlX3ZvdGVfaGVhZGVyGA8gASgJEiUKCXF1ZXN0aW9ucxgHIAMoCzISLmZvcm1zLnYxLlF1ZXN0aW9uEiAKBndpbmRvdxgIIAEoCzIQLmZvcm1zLnYxLldpbmRvdxI3Cg5wcmVfdm90ZV9zdGFydBgQIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBIAIgBARI3Chhwb3N0X3ZvdGVfcmVzdWx0c193aW5kb3cYDiABKAsyEC5mb3Jtcy52MS5XaW5kb3dIAYgBARIQCgh0aW1lem9uZRgaIAEoCRIuCgpjcmVhdGVkX2F0GAkgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIuCgp1cGRhdGVkX2F0GAogASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIvCgthcmNoaXZlZF9hdBgZIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBCEQoPX3ByZV92b3RlX3N0YXJ0QhsKGV9wb3N0X3ZvdGVfcmVzdWx0c193aW5kb3ciiQUKEUNyZWF0ZVBvbGxSZXF1ZXN0Eg4KBm9yZ19pZBgBIAEoCRIUCgx3b3Jrc3BhY2VfaWQYAiABKAkSDQoFdGl0bGUYAyABKAkSEwoLZGVzY3JpcHRpb24YBCABKAkSJQoJcXVlc3Rpb25zGAUgAygLMhIuZm9ybXMudjEuUXVlc3Rpb24SIAoGd2luZG93GAYgASgLMhAuZm9ybXMudjEuV2luZG93Eg8KB2hlYWRpbmcYByABKAkSFgoJb3BhcXVlX2lkGAggASgJSACIAQESGQoReW91cl9hbnN3ZXJfbGFiZWwYCSABKAkSHwoXc2hvd19wcmVfdm90ZV9jb3VudGRvd24YCiABKAgSFwoPcHJlX3ZvdGVfaGVhZGVyGAwgASgJEhMKC2hlbHBlcl90ZXh0GA0gASgJEhsKE3Jlc3VsdHNfaGVscGVyX3RleHQYDiABKAkSGAoQc2tpcF9idXR0b25fdGV4dBgPIAEoCRIaChJzdWJtaXRfYnV0dG9uX3RleHQYECABKAkSHAoUY29tcGxldGVfYnV0dG9uX3RleHQYESABKAkSGwoTcmVzdGFydF9idXR0b25fdGV4dBgTIAEoCRI3Cg5wcmVfdm90ZV9zdGFydBgSIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBIAYgBARI3Chhwb3N0X3ZvdGVfcmVzdWx0c193aW5kb3cYCyABKAsyEC5mb3Jtcy52MS5XaW5kb3dIAogBARIQCgh0aW1lem9uZRgUIAEoCUIMCgpfb3BhcXVlX2lkQhEKD19wcmVfdm90ZV9zdGFydEIbChlfcG9zdF92b3RlX3Jlc3VsdHNfd2luZG93IjIKEkNyZWF0ZVBvbGxSZXNwb25zZRIcCgRwb2xsGAEgASgLMg4uZm9ybXMudjEuUG9sbCJBCg1TZXNzaW9uQW5zd2VyEhMKC3F1ZXN0aW9uX2lkGAEgASgJEg0KBXZhbHVlGAIgASgJEgwKBG5hbWUYAyABKAkiWQoOR2V0UG9sbFJlcXVlc3QSCgoCaWQYASABKAkSDwoHdmVyc2lvbhgCIAEoCRIZCgxzdWJtaXR0ZXJfaWQYAyABKAlIAIgBAUIPCg1fc3VibWl0dGVyX2lkInQKD0dldFBvbGxSZXNwb25zZRIcCgRwb2xsGAEgASgLMg4uZm9ybXMudjEuUG9sbBIvCg5xdWVzdGlvbl9zdGF0cxgCIAMoCzIXLmZvcm1zLnYxLlF1ZXN0aW9uU3RhdHMSEgoKc2Vzc2lvbl9pZBgDIAEoCSJbChFVcGRhdGVQb2xsUmVxdWVzdBIcCgRwb2xsGAEgASgLMg4uZm9ybXMudjEuUG9sbBIoCgRtYXNrGAIgASgLMhouZ29vZ2xlLnByb3RvYnVmLkZpZWxkTWFzayIyChJVcGRhdGVQb2xsUmVzcG9uc2USHAoEcG9sbBgBIAEoCzIOLmZvcm1zLnYxLlBvbGwiMAoRRGVsZXRlUG9sbFJlcXVlc3QSCgoCaWQYASABKAkSDwoHdmVyc2lvbhgCIAEoCSIUChJEZWxldGVQb2xsUmVzcG9uc2UisAEKClBvbGxGaWx0ZXISDgoGc3RhdGVzGAEgAygJEhkKDHN1Ym1pdHRlcl9pZBgCIAEoCUgAiAEBEhYKCW9wYXF1ZV9pZBgDIAEoCUgBiAEBEjIKCWFjdGl2ZV9hdBgEIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBIAogBAUIPCg1fc3VibWl0dGVyX2lkQgwKCl9vcGFxdWVfaWRCDAoKX2FjdGl2ZV9hdCLIAQoQTGlzdFBvbGxzUmVxdWVzdBIOCgZvcmdfaWQYASABKAkSFAoMd29ya3NwYWNlX2lkGAIgASgJEjIKCnBhZ2luYXRpb24YAyABKAsyHi5jb21tb24udjEuUGFnaW5hdGlvbkFyZ3VtZW50cxIkCgZmaWx0ZXIYByABKAsyFC5mb3Jtcy52MS5Qb2xsRmlsdGVySgQIBBAFSgQIBRAGSgQIBhAHUglhY3RpdmVfYXRSDHN1Ym1pdHRlcl9pZFIJb3BhcXVlX2lkIl4KDVBvbGxXaXRoU3RhdHMSHAoEcG9sbBgBIAEoCzIOLmZvcm1zLnYxLlBvbGwSLwoOcXVlc3Rpb25fc3RhdHMYAiADKAsyFy5mb3Jtcy52MS5RdWVzdGlvblN0YXRzIowBChFMaXN0UG9sbHNSZXNwb25zZRIdCgVwb2xscxgBIAMoCzIOLmZvcm1zLnYxLlBvbGwSMAoJcGFnZV9pbmZvGAIgASgLMh0uY29tbW9uLnYxLlBhZ2luYXRpb25QYWdlSW5mbxImCgVpdGVtcxgDIAMoCzIXLmZvcm1zLnYxLlBvbGxXaXRoU3RhdHMiXwoPUG9sbEFuc3dlclN0YXRzEikKC3BvbGxfYW5zd2VyGAEgASgLMhQuZm9ybXMudjEuUG9sbEFuc3dlchINCgVjb3VudBgCIAEoAxISCgpwZXJjZW50YWdlGAMgASgBIs4BCg1RdWVzdGlvblN0YXRzEjQKEXBvbGxfYW5zd2VyX3N0YXRzGAEgAygLMhkuZm9ybXMudjEuUG9sbEFuc3dlclN0YXRzEhoKEnRvdGFsX3BvbGxfYW5zd2VycxgCIAEoAxIzChB1c2VyX3BvbGxfYW5zd2VyGAMgASgLMhQuZm9ybXMudjEuUG9sbEFuc3dlckgAiAEBEhMKC3F1ZXN0aW9uX2lkGAQgASgJEgwKBG5hbWUYBSABKAlCEwoRX3VzZXJfcG9sbF9hbnN3ZXIieAoXU3VibWl0UG9sbEFuc3dlclJlcXVlc3QSEwoLcXVlc3Rpb25faWQYASABKAkSDQoFdmFsdWUYAiABKAkSFAoMc3VibWl0dGVyX2lkGAMgASgJEg8KB3BvbGxfaWQYBCABKAkSEgoKc2Vzc2lvbl9pZBgFIAEoCSJLChhTdWJtaXRQb2xsQW5zd2VyUmVzcG9uc2USLwoOcXVlc3Rpb25fc3RhdHMYASABKAsyFy5mb3Jtcy52MS5RdWVzdGlvblN0YXRzIn8KF0dldFF1ZXN0aW9uU3RhdHNSZXF1ZXN0Eg8KB3BvbGxfaWQYBCABKAkSEwoLcXVlc3Rpb25faWQYASABKAkSGQoMc3VibWl0dGVyX2lkGAIgASgJSACIAQESEgoKc2Vzc2lvbl9pZBgDIAEoCUIPCg1fc3VibWl0dGVyX2lkIksKGEdldFF1ZXN0aW9uU3RhdHNSZXNwb25zZRIvCg5xdWVzdGlvbl9zdGF0cxgBIAEoCzIXLmZvcm1zLnYxLlF1ZXN0aW9uU3RhdHMiZgoTR2V0UG9sbFN0YXRzUmVxdWVzdBIPCgdwb2xsX2lkGAEgASgJEhkKDHN1Ym1pdHRlcl9pZBgCIAEoCUgAiAEBEhIKCnNlc3Npb25faWQYAyABKAlCDwoNX3N1Ym1pdHRlcl9pZCJHChRHZXRQb2xsU3RhdHNSZXNwb25zZRIvCg5xdWVzdGlvbl9zdGF0cxgBIAMoCzIXLmZvcm1zLnYxLlF1ZXN0aW9uU3RhdHMibwoSRW5kU2Vzc2lvblJlc3BvbnNlEi8KDnF1ZXN0aW9uX3N0YXRzGAEgAygLMhcuZm9ybXMudjEuUXVlc3Rpb25TdGF0cxIoCgdhbnN3ZXJzGAIgAygLMhcuZm9ybXMudjEuU2Vzc2lvbkFuc3dlciLxAQoLUG9sbFZvdGVSb3cSFAoMc3VibWl0dGVyX2lkGAEgASgJEhIKCnNlc3Npb25faWQYAiABKAkSFgoOc2Vzc2lvbl9zdGF0dXMYAyABKAkSKAoHYW5zd2VycxgEIAMoCzIXLmZvcm1zLnYxLlNlc3Npb25BbnN3ZXISLgoKY3JlYXRlZF9hdBgFIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASNQoMY29tcGxldGVkX2F0GAYgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEgAiAEBQg8KDV9jb21wbGV0ZWRfYXQisQEKFExpc3RQb2xsVm90ZXNSZXF1ZXN0Eg8KB3BvbGxfaWQYASABKAkSMgoKcGFnaW5hdGlvbhgCIAEoCzIeLmNvbW1vbi52MS5QYWdpbmF0aW9uQXJndW1lbnRzEhgKC3F1ZXN0aW9uX2lkGAMgASgJSACIAQESGQoMc3VibWl0dGVyX2lkGAQgASgJSAGIAQFCDgoMX3F1ZXN0aW9uX2lkQg8KDV9zdWJtaXR0ZXJfaWQibwoVTGlzdFBvbGxWb3Rlc1Jlc3BvbnNlEiQKBXZvdGVzGAEgAygLMhUuZm9ybXMudjEuUG9sbFZvdGVSb3cSMAoJcGFnZV9pbmZvGAIgASgLMh0uY29tbW9uLnYxLlBhZ2luYXRpb25QYWdlSW5mbzL5BQoLUG9sbFNlcnZpY2USTwoKQ3JlYXRlUG9sbBIbLmZvcm1zLnYxLkNyZWF0ZVBvbGxSZXF1ZXN0GhwuZm9ybXMudjEuQ3JlYXRlUG9sbFJlc3BvbnNlIgbC7RoCCAISRAoHR2V0UG9sbBIYLmZvcm1zLnYxLkdldFBvbGxSZXF1ZXN0GhkuZm9ybXMudjEuR2V0UG9sbFJlc3BvbnNlIgTC7RoAEk8KClVwZGF0ZVBvbGwSGy5mb3Jtcy52MS5VcGRhdGVQb2xsUmVxdWVzdBocLmZvcm1zLnYxLlVwZGF0ZVBvbGxSZXNwb25zZSIGwu0aAggCEk8KCkRlbGV0ZVBvbGwSGy5mb3Jtcy52MS5EZWxldGVQb2xsUmVxdWVzdBocLmZvcm1zLnYxLkRlbGV0ZVBvbGxSZXNwb25zZSIGwu0aAggCEkwKCUxpc3RQb2xscxIaLmZvcm1zLnYxLkxpc3RQb2xsc1JlcXVlc3QaGy5mb3Jtcy52MS5MaXN0UG9sbHNSZXNwb25zZSIGwu0aAggCElgKDUxpc3RQb2xsVm90ZXMSHi5mb3Jtcy52MS5MaXN0UG9sbFZvdGVzUmVxdWVzdBofLmZvcm1zLnYxLkxpc3RQb2xsVm90ZXNSZXNwb25zZSIGwu0aAggCElsKEFN1Ym1pdFBvbGxBbnN3ZXISIS5mb3Jtcy52MS5TdWJtaXRQb2xsQW5zd2VyUmVxdWVzdBoiLmZvcm1zLnYxLlN1Ym1pdFBvbGxBbnN3ZXJSZXNwb25zZSIAElsKEEdldFF1ZXN0aW9uU3RhdHMSIS5mb3Jtcy52MS5HZXRRdWVzdGlvblN0YXRzUmVxdWVzdBoiLmZvcm1zLnYxLkdldFF1ZXN0aW9uU3RhdHNSZXNwb25zZSIAEk8KDEdldFBvbGxTdGF0cxIdLmZvcm1zLnYxLkdldFBvbGxTdGF0c1JlcXVlc3QaHi5mb3Jtcy52MS5HZXRQb2xsU3RhdHNSZXNwb25zZSIAYgZwcm90bzM",
		[file_common_v1_annotations, file_common_v1_pagination, file_common_v1_types, file_google_protobuf_field_mask, file_google_protobuf_timestamp],
	);

/**
 * @generated from message forms.v1.Window
 */
export type Window = Message<"forms.v1.Window"> & {
	/**
	 * @generated from field: google.protobuf.Timestamp start = 1;
	 */
	start?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp end = 2;
	 */
	end?: Timestamp | undefined;
};

/**
 * @generated from message forms.v1.Window
 */
export type WindowJson = {
	/**
	 * @generated from field: google.protobuf.Timestamp start = 1;
	 */
	start?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp end = 2;
	 */
	end?: TimestampJson;
};

/**
 * Describes the message forms.v1.Window.
 * Use `create(WindowSchema)` to create a new message.
 */
export const WindowSchema: GenMessage<Window, { jsonType: WindowJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_poll, 0);

/**
 * @generated from message forms.v1.Image
 */
export type Image = Message<"forms.v1.Image"> & {
	/**
	 * @generated from field: string image_url = 1;
	 */
	imageUrl: string;

	/**
	 * @generated from field: string alt_text = 2;
	 */
	altText: string;
};

/**
 * @generated from message forms.v1.Image
 */
export type ImageJson = {
	/**
	 * @generated from field: string image_url = 1;
	 */
	imageUrl?: string;

	/**
	 * @generated from field: string alt_text = 2;
	 */
	altText?: string;
};

/**
 * Describes the message forms.v1.Image.
 * Use `create(ImageSchema)` to create a new message.
 */
export const ImageSchema: GenMessage<Image, { jsonType: ImageJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_poll, 1);

/**
 * @generated from message forms.v1.PollAnswer
 */
export type PollAnswer = Message<"forms.v1.PollAnswer"> & {
	/**
	 * stable identifier for the option; used as the vote tally key
	 *
	 * @generated from field: string value = 1;
	 */
	value: string;

	/**
	 * optional display label (e.g. "Illinois")
	 *
	 * @generated from field: string primary_label = 2;
	 */
	primaryLabel: string;

	/**
	 * optional secondary label (e.g. "Home" / "Away")
	 *
	 * @generated from field: string secondary_label = 3;
	 */
	secondaryLabel: string;

	/**
	 * optional image/logo for the option
	 *
	 * @generated from field: forms.v1.Image image = 4;
	 */
	image?: Image | undefined;
};

/**
 * @generated from message forms.v1.PollAnswer
 */
export type PollAnswerJson = {
	/**
	 * stable identifier for the option; used as the vote tally key
	 *
	 * @generated from field: string value = 1;
	 */
	value?: string;

	/**
	 * optional display label (e.g. "Illinois")
	 *
	 * @generated from field: string primary_label = 2;
	 */
	primaryLabel?: string;

	/**
	 * optional secondary label (e.g. "Home" / "Away")
	 *
	 * @generated from field: string secondary_label = 3;
	 */
	secondaryLabel?: string;

	/**
	 * optional image/logo for the option
	 *
	 * @generated from field: forms.v1.Image image = 4;
	 */
	image?: ImageJson;
};

/**
 * Describes the message forms.v1.PollAnswer.
 * Use `create(PollAnswerSchema)` to create a new message.
 */
export const PollAnswerSchema: GenMessage<PollAnswer, { jsonType: PollAnswerJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_poll, 2);

/**
 * @generated from message forms.v1.Question
 */
export type Question = Message<"forms.v1.Question"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string poll_id = 2;
	 */
	pollId: string;

	/**
	 * the question posed to voters
	 *
	 * @generated from field: string question = 3;
	 */
	question: string;

	/**
	 * the name to give this question (ex Poll 1)
	 *
	 * @generated from field: string name = 6;
	 */
	name: string;

	/**
	 * optional supporting copy shown beneath the question
	 *
	 * @generated from field: string description = 4;
	 */
	description: string;

	/**
	 * optional alternative text for the question (ex Vs, Or, etc)
	 *
	 * @generated from field: optional string alternative_text = 7;
	 */
	alternativeText?: string | undefined;

	/**
	 * @generated from field: repeated forms.v1.PollAnswer poll_answers = 5;
	 */
	pollAnswers: PollAnswer[];
};

/**
 * @generated from message forms.v1.Question
 */
export type QuestionJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string poll_id = 2;
	 */
	pollId?: string;

	/**
	 * the question posed to voters
	 *
	 * @generated from field: string question = 3;
	 */
	question?: string;

	/**
	 * the name to give this question (ex Poll 1)
	 *
	 * @generated from field: string name = 6;
	 */
	name?: string;

	/**
	 * optional supporting copy shown beneath the question
	 *
	 * @generated from field: string description = 4;
	 */
	description?: string;

	/**
	 * optional alternative text for the question (ex Vs, Or, etc)
	 *
	 * @generated from field: optional string alternative_text = 7;
	 */
	alternativeText?: string;

	/**
	 * @generated from field: repeated forms.v1.PollAnswer poll_answers = 5;
	 */
	pollAnswers?: PollAnswerJson[];
};

/**
 * Describes the message forms.v1.Question.
 * Use `create(QuestionSchema)` to create a new message.
 */
export const QuestionSchema: GenMessage<Question, { jsonType: QuestionJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_poll, 3);

/**
 * @generated from message forms.v1.Poll
 */
export type Poll = Message<"forms.v1.Poll"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version: string;

	/**
	 * @generated from field: string org_id = 3;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 4;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string title = 5;
	 */
	title: string;

	/**
	 * @generated from field: string description = 6;
	 */
	description: string;

	/**
	 * @generated from field: string state = 24;
	 */
	state: string;

	/**
	 * @generated from field: common.v1.Creator creator = 23;
	 */
	creator?: Creator | undefined;

	/**
	 * @generated from field: string heading = 11;
	 */
	heading: string;

	/**
	 * @generated from field: string helper_text = 17;
	 */
	helperText: string;

	/**
	 * @generated from field: string results_helper_text = 18;
	 */
	resultsHelperText: string;

	/**
	 * @generated from field: string skip_button_text = 19;
	 */
	skipButtonText: string;

	/**
	 * @generated from field: string submit_button_text = 20;
	 */
	submitButtonText: string;

	/**
	 * @generated from field: string complete_button_text = 21;
	 */
	completeButtonText: string;

	/**
	 * @generated from field: string restart_button_text = 22;
	 */
	restartButtonText: string;

	/**
	 * @generated from field: string your_answer_label = 12;
	 */
	yourAnswerLabel: string;

	/**
	 * @generated from field: bool show_pre_vote_countdown = 13;
	 */
	showPreVoteCountdown: boolean;

	/**
	 * @generated from field: string pre_vote_header = 15;
	 */
	preVoteHeader: string;

	/**
	 * @generated from field: repeated forms.v1.Question questions = 7;
	 */
	questions: Question[];

	/**
	 * @generated from field: forms.v1.Window window = 8;
	 */
	window?: Window | undefined;

	/**
	 * @generated from field: optional google.protobuf.Timestamp pre_vote_start = 16;
	 */
	preVoteStart?: Timestamp | undefined;

	/**
	 * @generated from field: optional forms.v1.Window post_vote_results_window = 14;
	 */
	postVoteResultsWindow?: Window | undefined;

	/**
	 * @generated from field: string timezone = 26;
	 */
	timezone: string;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 9;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 10;
	 */
	updatedAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp archived_at = 25;
	 */
	archivedAt?: Timestamp | undefined;
};

/**
 * @generated from message forms.v1.Poll
 */
export type PollJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version?: string;

	/**
	 * @generated from field: string org_id = 3;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 4;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string title = 5;
	 */
	title?: string;

	/**
	 * @generated from field: string description = 6;
	 */
	description?: string;

	/**
	 * @generated from field: string state = 24;
	 */
	state?: string;

	/**
	 * @generated from field: common.v1.Creator creator = 23;
	 */
	creator?: CreatorJson;

	/**
	 * @generated from field: string heading = 11;
	 */
	heading?: string;

	/**
	 * @generated from field: string helper_text = 17;
	 */
	helperText?: string;

	/**
	 * @generated from field: string results_helper_text = 18;
	 */
	resultsHelperText?: string;

	/**
	 * @generated from field: string skip_button_text = 19;
	 */
	skipButtonText?: string;

	/**
	 * @generated from field: string submit_button_text = 20;
	 */
	submitButtonText?: string;

	/**
	 * @generated from field: string complete_button_text = 21;
	 */
	completeButtonText?: string;

	/**
	 * @generated from field: string restart_button_text = 22;
	 */
	restartButtonText?: string;

	/**
	 * @generated from field: string your_answer_label = 12;
	 */
	yourAnswerLabel?: string;

	/**
	 * @generated from field: bool show_pre_vote_countdown = 13;
	 */
	showPreVoteCountdown?: boolean;

	/**
	 * @generated from field: string pre_vote_header = 15;
	 */
	preVoteHeader?: string;

	/**
	 * @generated from field: repeated forms.v1.Question questions = 7;
	 */
	questions?: QuestionJson[];

	/**
	 * @generated from field: forms.v1.Window window = 8;
	 */
	window?: WindowJson;

	/**
	 * @generated from field: optional google.protobuf.Timestamp pre_vote_start = 16;
	 */
	preVoteStart?: TimestampJson;

	/**
	 * @generated from field: optional forms.v1.Window post_vote_results_window = 14;
	 */
	postVoteResultsWindow?: WindowJson;

	/**
	 * @generated from field: string timezone = 26;
	 */
	timezone?: string;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 9;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 10;
	 */
	updatedAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp archived_at = 25;
	 */
	archivedAt?: TimestampJson;
};

/**
 * Describes the message forms.v1.Poll.
 * Use `create(PollSchema)` to create a new message.
 */
export const PollSchema: GenMessage<Poll, { jsonType: PollJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_poll, 4);

/**
 * @generated from message forms.v1.CreatePollRequest
 */
export type CreatePollRequest = Message<"forms.v1.CreatePollRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string title = 3;
	 */
	title: string;

	/**
	 * @generated from field: string description = 4;
	 */
	description: string;

	/**
	 * @generated from field: repeated forms.v1.Question questions = 5;
	 */
	questions: Question[];

	/**
	 * @generated from field: forms.v1.Window window = 6;
	 */
	window?: Window | undefined;

	/**
	 * @generated from field: string heading = 7;
	 */
	heading: string;

	/**
	 * @generated from field: optional string opaque_id = 8;
	 */
	opaqueId?: string | undefined;

	/**
	 * @generated from field: string your_answer_label = 9;
	 */
	yourAnswerLabel: string;

	/**
	 * @generated from field: bool show_pre_vote_countdown = 10;
	 */
	showPreVoteCountdown: boolean;

	/**
	 * @generated from field: string pre_vote_header = 12;
	 */
	preVoteHeader: string;

	/**
	 * @generated from field: string helper_text = 13;
	 */
	helperText: string;

	/**
	 * @generated from field: string results_helper_text = 14;
	 */
	resultsHelperText: string;

	/**
	 * @generated from field: string skip_button_text = 15;
	 */
	skipButtonText: string;

	/**
	 * @generated from field: string submit_button_text = 16;
	 */
	submitButtonText: string;

	/**
	 * @generated from field: string complete_button_text = 17;
	 */
	completeButtonText: string;

	/**
	 * @generated from field: string restart_button_text = 19;
	 */
	restartButtonText: string;

	/**
	 * @generated from field: optional google.protobuf.Timestamp pre_vote_start = 18;
	 */
	preVoteStart?: Timestamp | undefined;

	/**
	 * @generated from field: optional forms.v1.Window post_vote_results_window = 11;
	 */
	postVoteResultsWindow?: Window | undefined;

	/**
	 * @generated from field: string timezone = 20;
	 */
	timezone: string;
};

/**
 * @generated from message forms.v1.CreatePollRequest
 */
export type CreatePollRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string title = 3;
	 */
	title?: string;

	/**
	 * @generated from field: string description = 4;
	 */
	description?: string;

	/**
	 * @generated from field: repeated forms.v1.Question questions = 5;
	 */
	questions?: QuestionJson[];

	/**
	 * @generated from field: forms.v1.Window window = 6;
	 */
	window?: WindowJson;

	/**
	 * @generated from field: string heading = 7;
	 */
	heading?: string;

	/**
	 * @generated from field: optional string opaque_id = 8;
	 */
	opaqueId?: string;

	/**
	 * @generated from field: string your_answer_label = 9;
	 */
	yourAnswerLabel?: string;

	/**
	 * @generated from field: bool show_pre_vote_countdown = 10;
	 */
	showPreVoteCountdown?: boolean;

	/**
	 * @generated from field: string pre_vote_header = 12;
	 */
	preVoteHeader?: string;

	/**
	 * @generated from field: string helper_text = 13;
	 */
	helperText?: string;

	/**
	 * @generated from field: string results_helper_text = 14;
	 */
	resultsHelperText?: string;

	/**
	 * @generated from field: string skip_button_text = 15;
	 */
	skipButtonText?: string;

	/**
	 * @generated from field: string submit_button_text = 16;
	 */
	submitButtonText?: string;

	/**
	 * @generated from field: string complete_button_text = 17;
	 */
	completeButtonText?: string;

	/**
	 * @generated from field: string restart_button_text = 19;
	 */
	restartButtonText?: string;

	/**
	 * @generated from field: optional google.protobuf.Timestamp pre_vote_start = 18;
	 */
	preVoteStart?: TimestampJson;

	/**
	 * @generated from field: optional forms.v1.Window post_vote_results_window = 11;
	 */
	postVoteResultsWindow?: WindowJson;

	/**
	 * @generated from field: string timezone = 20;
	 */
	timezone?: string;
};

/**
 * Describes the message forms.v1.CreatePollRequest.
 * Use `create(CreatePollRequestSchema)` to create a new message.
 */
export const CreatePollRequestSchema: GenMessage<CreatePollRequest, { jsonType: CreatePollRequestJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_poll, 5);

/**
 * @generated from message forms.v1.CreatePollResponse
 */
export type CreatePollResponse = Message<"forms.v1.CreatePollResponse"> & {
	/**
	 * @generated from field: forms.v1.Poll poll = 1;
	 */
	poll?: Poll | undefined;
};

/**
 * @generated from message forms.v1.CreatePollResponse
 */
export type CreatePollResponseJson = {
	/**
	 * @generated from field: forms.v1.Poll poll = 1;
	 */
	poll?: PollJson;
};

/**
 * Describes the message forms.v1.CreatePollResponse.
 * Use `create(CreatePollResponseSchema)` to create a new message.
 */
export const CreatePollResponseSchema: GenMessage<CreatePollResponse, { jsonType: CreatePollResponseJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_poll, 6);

/**
 * @generated from message forms.v1.SessionAnswer
 */
export type SessionAnswer = Message<"forms.v1.SessionAnswer"> & {
	/**
	 * @generated from field: string question_id = 1;
	 */
	questionId: string;

	/**
	 * @generated from field: string value = 2;
	 */
	value: string;

	/**
	 * @generated from field: string name = 3;
	 */
	name: string;
};

/**
 * @generated from message forms.v1.SessionAnswer
 */
export type SessionAnswerJson = {
	/**
	 * @generated from field: string question_id = 1;
	 */
	questionId?: string;

	/**
	 * @generated from field: string value = 2;
	 */
	value?: string;

	/**
	 * @generated from field: string name = 3;
	 */
	name?: string;
};

/**
 * Describes the message forms.v1.SessionAnswer.
 * Use `create(SessionAnswerSchema)` to create a new message.
 */
export const SessionAnswerSchema: GenMessage<SessionAnswer, { jsonType: SessionAnswerJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_poll, 7);

/**
 * @generated from message forms.v1.GetPollRequest
 */
export type GetPollRequest = Message<"forms.v1.GetPollRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version: string;

	/**
	 * @generated from field: optional string submitter_id = 3;
	 */
	submitterId?: string | undefined;
};

/**
 * @generated from message forms.v1.GetPollRequest
 */
export type GetPollRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version?: string;

	/**
	 * @generated from field: optional string submitter_id = 3;
	 */
	submitterId?: string;
};

/**
 * Describes the message forms.v1.GetPollRequest.
 * Use `create(GetPollRequestSchema)` to create a new message.
 */
export const GetPollRequestSchema: GenMessage<GetPollRequest, { jsonType: GetPollRequestJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_poll, 8);

/**
 * @generated from message forms.v1.GetPollResponse
 */
export type GetPollResponse = Message<"forms.v1.GetPollResponse"> & {
	/**
	 * @generated from field: forms.v1.Poll poll = 1;
	 */
	poll?: Poll | undefined;

	/**
	 * @generated from field: repeated forms.v1.QuestionStats question_stats = 2;
	 */
	questionStats: QuestionStats[];

	/**
	 * @generated from field: string session_id = 3;
	 */
	sessionId: string;
};

/**
 * @generated from message forms.v1.GetPollResponse
 */
export type GetPollResponseJson = {
	/**
	 * @generated from field: forms.v1.Poll poll = 1;
	 */
	poll?: PollJson;

	/**
	 * @generated from field: repeated forms.v1.QuestionStats question_stats = 2;
	 */
	questionStats?: QuestionStatsJson[];

	/**
	 * @generated from field: string session_id = 3;
	 */
	sessionId?: string;
};

/**
 * Describes the message forms.v1.GetPollResponse.
 * Use `create(GetPollResponseSchema)` to create a new message.
 */
export const GetPollResponseSchema: GenMessage<GetPollResponse, { jsonType: GetPollResponseJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_poll, 9);

/**
 * @generated from message forms.v1.UpdatePollRequest
 */
export type UpdatePollRequest = Message<"forms.v1.UpdatePollRequest"> & {
	/**
	 * @generated from field: forms.v1.Poll poll = 1;
	 */
	poll?: Poll | undefined;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMask | undefined;
};

/**
 * @generated from message forms.v1.UpdatePollRequest
 */
export type UpdatePollRequestJson = {
	/**
	 * @generated from field: forms.v1.Poll poll = 1;
	 */
	poll?: PollJson;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMaskJson;
};

/**
 * Describes the message forms.v1.UpdatePollRequest.
 * Use `create(UpdatePollRequestSchema)` to create a new message.
 */
export const UpdatePollRequestSchema: GenMessage<UpdatePollRequest, { jsonType: UpdatePollRequestJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_poll, 10);

/**
 * @generated from message forms.v1.UpdatePollResponse
 */
export type UpdatePollResponse = Message<"forms.v1.UpdatePollResponse"> & {
	/**
	 * @generated from field: forms.v1.Poll poll = 1;
	 */
	poll?: Poll | undefined;
};

/**
 * @generated from message forms.v1.UpdatePollResponse
 */
export type UpdatePollResponseJson = {
	/**
	 * @generated from field: forms.v1.Poll poll = 1;
	 */
	poll?: PollJson;
};

/**
 * Describes the message forms.v1.UpdatePollResponse.
 * Use `create(UpdatePollResponseSchema)` to create a new message.
 */
export const UpdatePollResponseSchema: GenMessage<UpdatePollResponse, { jsonType: UpdatePollResponseJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_poll, 11);

/**
 * @generated from message forms.v1.DeletePollRequest
 */
export type DeletePollRequest = Message<"forms.v1.DeletePollRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version: string;
};

/**
 * @generated from message forms.v1.DeletePollRequest
 */
export type DeletePollRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version?: string;
};

/**
 * Describes the message forms.v1.DeletePollRequest.
 * Use `create(DeletePollRequestSchema)` to create a new message.
 */
export const DeletePollRequestSchema: GenMessage<DeletePollRequest, { jsonType: DeletePollRequestJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_poll, 12);

/**
 * @generated from message forms.v1.DeletePollResponse
 */
export type DeletePollResponse = Message<"forms.v1.DeletePollResponse"> & {};

/**
 * @generated from message forms.v1.DeletePollResponse
 */
export type DeletePollResponseJson = {};

/**
 * Describes the message forms.v1.DeletePollResponse.
 * Use `create(DeletePollResponseSchema)` to create a new message.
 */
export const DeletePollResponseSchema: GenMessage<DeletePollResponse, { jsonType: DeletePollResponseJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_poll, 13);

/**
 * @generated from message forms.v1.PollFilter
 */
export type PollFilter = Message<"forms.v1.PollFilter"> & {
	/**
	 * @generated from field: repeated string states = 1;
	 */
	states: string[];

	/**
	 * @generated from field: optional string submitter_id = 2;
	 */
	submitterId?: string | undefined;

	/**
	 * @generated from field: optional string opaque_id = 3;
	 */
	opaqueId?: string | undefined;

	/**
	 * if set, returns only polls open at this time (window contains active_at);
	 * unset returns polls regardless of their window
	 *
	 * @generated from field: optional google.protobuf.Timestamp active_at = 4;
	 */
	activeAt?: Timestamp | undefined;
};

/**
 * @generated from message forms.v1.PollFilter
 */
export type PollFilterJson = {
	/**
	 * @generated from field: repeated string states = 1;
	 */
	states?: string[];

	/**
	 * @generated from field: optional string submitter_id = 2;
	 */
	submitterId?: string;

	/**
	 * @generated from field: optional string opaque_id = 3;
	 */
	opaqueId?: string;

	/**
	 * if set, returns only polls open at this time (window contains active_at);
	 * unset returns polls regardless of their window
	 *
	 * @generated from field: optional google.protobuf.Timestamp active_at = 4;
	 */
	activeAt?: TimestampJson;
};

/**
 * Describes the message forms.v1.PollFilter.
 * Use `create(PollFilterSchema)` to create a new message.
 */
export const PollFilterSchema: GenMessage<PollFilter, { jsonType: PollFilterJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_poll, 14);

/**
 * @generated from message forms.v1.ListPollsRequest
 */
export type ListPollsRequest = Message<"forms.v1.ListPollsRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 3;
	 */
	pagination?: PaginationArguments | undefined;

	/**
	 * @generated from field: forms.v1.PollFilter filter = 7;
	 */
	filter?: PollFilter | undefined;
};

/**
 * @generated from message forms.v1.ListPollsRequest
 */
export type ListPollsRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 3;
	 */
	pagination?: PaginationArgumentsJson;

	/**
	 * @generated from field: forms.v1.PollFilter filter = 7;
	 */
	filter?: PollFilterJson;
};

/**
 * Describes the message forms.v1.ListPollsRequest.
 * Use `create(ListPollsRequestSchema)` to create a new message.
 */
export const ListPollsRequestSchema: GenMessage<ListPollsRequest, { jsonType: ListPollsRequestJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_poll, 15);

/**
 * @generated from message forms.v1.PollWithStats
 */
export type PollWithStats = Message<"forms.v1.PollWithStats"> & {
	/**
	 * @generated from field: forms.v1.Poll poll = 1;
	 */
	poll?: Poll | undefined;

	/**
	 * @generated from field: repeated forms.v1.QuestionStats question_stats = 2;
	 */
	questionStats: QuestionStats[];
};

/**
 * @generated from message forms.v1.PollWithStats
 */
export type PollWithStatsJson = {
	/**
	 * @generated from field: forms.v1.Poll poll = 1;
	 */
	poll?: PollJson;

	/**
	 * @generated from field: repeated forms.v1.QuestionStats question_stats = 2;
	 */
	questionStats?: QuestionStatsJson[];
};

/**
 * Describes the message forms.v1.PollWithStats.
 * Use `create(PollWithStatsSchema)` to create a new message.
 */
export const PollWithStatsSchema: GenMessage<PollWithStats, { jsonType: PollWithStatsJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_poll, 16);

/**
 * @generated from message forms.v1.ListPollsResponse
 */
export type ListPollsResponse = Message<"forms.v1.ListPollsResponse"> & {
	/**
	 * @generated from field: repeated forms.v1.Poll polls = 1;
	 */
	polls: Poll[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;

	/**
	 * @generated from field: repeated forms.v1.PollWithStats items = 3;
	 */
	items: PollWithStats[];
};

/**
 * @generated from message forms.v1.ListPollsResponse
 */
export type ListPollsResponseJson = {
	/**
	 * @generated from field: repeated forms.v1.Poll polls = 1;
	 */
	polls?: PollJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;

	/**
	 * @generated from field: repeated forms.v1.PollWithStats items = 3;
	 */
	items?: PollWithStatsJson[];
};

/**
 * Describes the message forms.v1.ListPollsResponse.
 * Use `create(ListPollsResponseSchema)` to create a new message.
 */
export const ListPollsResponseSchema: GenMessage<ListPollsResponse, { jsonType: ListPollsResponseJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_poll, 17);

/**
 * @generated from message forms.v1.PollAnswerStats
 */
export type PollAnswerStats = Message<"forms.v1.PollAnswerStats"> & {
	/**
	 * @generated from field: forms.v1.PollAnswer poll_answer = 1;
	 */
	pollAnswer?: PollAnswer | undefined;

	/**
	 * @generated from field: int64 count = 2;
	 */
	count: bigint;

	/**
	 * @generated from field: double percentage = 3;
	 */
	percentage: number;
};

/**
 * @generated from message forms.v1.PollAnswerStats
 */
export type PollAnswerStatsJson = {
	/**
	 * @generated from field: forms.v1.PollAnswer poll_answer = 1;
	 */
	pollAnswer?: PollAnswerJson;

	/**
	 * @generated from field: int64 count = 2;
	 */
	count?: string;

	/**
	 * @generated from field: double percentage = 3;
	 */
	percentage?: number | "NaN" | "Infinity" | "-Infinity";
};

/**
 * Describes the message forms.v1.PollAnswerStats.
 * Use `create(PollAnswerStatsSchema)` to create a new message.
 */
export const PollAnswerStatsSchema: GenMessage<PollAnswerStats, { jsonType: PollAnswerStatsJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_poll, 18);

/**
 * @generated from message forms.v1.QuestionStats
 */
export type QuestionStats = Message<"forms.v1.QuestionStats"> & {
	/**
	 * @generated from field: repeated forms.v1.PollAnswerStats poll_answer_stats = 1;
	 */
	pollAnswerStats: PollAnswerStats[];

	/**
	 * @generated from field: int64 total_poll_answers = 2;
	 */
	totalPollAnswers: bigint;

	/**
	 * @generated from field: optional forms.v1.PollAnswer user_poll_answer = 3;
	 */
	userPollAnswer?: PollAnswer | undefined;

	/**
	 * @generated from field: string question_id = 4;
	 */
	questionId: string;

	/**
	 * @generated from field: string name = 5;
	 */
	name: string;
};

/**
 * @generated from message forms.v1.QuestionStats
 */
export type QuestionStatsJson = {
	/**
	 * @generated from field: repeated forms.v1.PollAnswerStats poll_answer_stats = 1;
	 */
	pollAnswerStats?: PollAnswerStatsJson[];

	/**
	 * @generated from field: int64 total_poll_answers = 2;
	 */
	totalPollAnswers?: string;

	/**
	 * @generated from field: optional forms.v1.PollAnswer user_poll_answer = 3;
	 */
	userPollAnswer?: PollAnswerJson;

	/**
	 * @generated from field: string question_id = 4;
	 */
	questionId?: string;

	/**
	 * @generated from field: string name = 5;
	 */
	name?: string;
};

/**
 * Describes the message forms.v1.QuestionStats.
 * Use `create(QuestionStatsSchema)` to create a new message.
 */
export const QuestionStatsSchema: GenMessage<QuestionStats, { jsonType: QuestionStatsJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_poll, 19);

/**
 * @generated from message forms.v1.SubmitPollAnswerRequest
 */
export type SubmitPollAnswerRequest = Message<"forms.v1.SubmitPollAnswerRequest"> & {
	/**
	 * @generated from field: string question_id = 1;
	 */
	questionId: string;

	/**
	 * selected option value, matching PollAnswer.value
	 *
	 * @generated from field: string value = 2;
	 */
	value: string;

	/**
	 * @generated from field: string submitter_id = 3;
	 */
	submitterId: string;

	/**
	 * @generated from field: string poll_id = 4;
	 */
	pollId: string;

	/**
	 * @generated from field: string session_id = 5;
	 */
	sessionId: string;
};

/**
 * @generated from message forms.v1.SubmitPollAnswerRequest
 */
export type SubmitPollAnswerRequestJson = {
	/**
	 * @generated from field: string question_id = 1;
	 */
	questionId?: string;

	/**
	 * selected option value, matching PollAnswer.value
	 *
	 * @generated from field: string value = 2;
	 */
	value?: string;

	/**
	 * @generated from field: string submitter_id = 3;
	 */
	submitterId?: string;

	/**
	 * @generated from field: string poll_id = 4;
	 */
	pollId?: string;

	/**
	 * @generated from field: string session_id = 5;
	 */
	sessionId?: string;
};

/**
 * Describes the message forms.v1.SubmitPollAnswerRequest.
 * Use `create(SubmitPollAnswerRequestSchema)` to create a new message.
 */
export const SubmitPollAnswerRequestSchema: GenMessage<SubmitPollAnswerRequest, { jsonType: SubmitPollAnswerRequestJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_poll, 20);

/**
 * @generated from message forms.v1.SubmitPollAnswerResponse
 */
export type SubmitPollAnswerResponse = Message<"forms.v1.SubmitPollAnswerResponse"> & {
	/**
	 * @generated from field: forms.v1.QuestionStats question_stats = 1;
	 */
	questionStats?: QuestionStats | undefined;
};

/**
 * @generated from message forms.v1.SubmitPollAnswerResponse
 */
export type SubmitPollAnswerResponseJson = {
	/**
	 * @generated from field: forms.v1.QuestionStats question_stats = 1;
	 */
	questionStats?: QuestionStatsJson;
};

/**
 * Describes the message forms.v1.SubmitPollAnswerResponse.
 * Use `create(SubmitPollAnswerResponseSchema)` to create a new message.
 */
export const SubmitPollAnswerResponseSchema: GenMessage<SubmitPollAnswerResponse, { jsonType: SubmitPollAnswerResponseJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_poll, 21);

/**
 * @generated from message forms.v1.GetQuestionStatsRequest
 */
export type GetQuestionStatsRequest = Message<"forms.v1.GetQuestionStatsRequest"> & {
	/**
	 * @generated from field: string poll_id = 4;
	 */
	pollId: string;

	/**
	 * @generated from field: string question_id = 1;
	 */
	questionId: string;

	/**
	 * @generated from field: optional string submitter_id = 2;
	 */
	submitterId?: string | undefined;

	/**
	 * @generated from field: string session_id = 3;
	 */
	sessionId: string;
};

/**
 * @generated from message forms.v1.GetQuestionStatsRequest
 */
export type GetQuestionStatsRequestJson = {
	/**
	 * @generated from field: string poll_id = 4;
	 */
	pollId?: string;

	/**
	 * @generated from field: string question_id = 1;
	 */
	questionId?: string;

	/**
	 * @generated from field: optional string submitter_id = 2;
	 */
	submitterId?: string;

	/**
	 * @generated from field: string session_id = 3;
	 */
	sessionId?: string;
};

/**
 * Describes the message forms.v1.GetQuestionStatsRequest.
 * Use `create(GetQuestionStatsRequestSchema)` to create a new message.
 */
export const GetQuestionStatsRequestSchema: GenMessage<GetQuestionStatsRequest, { jsonType: GetQuestionStatsRequestJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_poll, 22);

/**
 * @generated from message forms.v1.GetQuestionStatsResponse
 */
export type GetQuestionStatsResponse = Message<"forms.v1.GetQuestionStatsResponse"> & {
	/**
	 * @generated from field: forms.v1.QuestionStats question_stats = 1;
	 */
	questionStats?: QuestionStats | undefined;
};

/**
 * @generated from message forms.v1.GetQuestionStatsResponse
 */
export type GetQuestionStatsResponseJson = {
	/**
	 * @generated from field: forms.v1.QuestionStats question_stats = 1;
	 */
	questionStats?: QuestionStatsJson;
};

/**
 * Describes the message forms.v1.GetQuestionStatsResponse.
 * Use `create(GetQuestionStatsResponseSchema)` to create a new message.
 */
export const GetQuestionStatsResponseSchema: GenMessage<GetQuestionStatsResponse, { jsonType: GetQuestionStatsResponseJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_poll, 23);

/**
 * @generated from message forms.v1.GetPollStatsRequest
 */
export type GetPollStatsRequest = Message<"forms.v1.GetPollStatsRequest"> & {
	/**
	 * @generated from field: string poll_id = 1;
	 */
	pollId: string;

	/**
	 * @generated from field: optional string submitter_id = 2;
	 */
	submitterId?: string | undefined;

	/**
	 * @generated from field: string session_id = 3;
	 */
	sessionId: string;
};

/**
 * @generated from message forms.v1.GetPollStatsRequest
 */
export type GetPollStatsRequestJson = {
	/**
	 * @generated from field: string poll_id = 1;
	 */
	pollId?: string;

	/**
	 * @generated from field: optional string submitter_id = 2;
	 */
	submitterId?: string;

	/**
	 * @generated from field: string session_id = 3;
	 */
	sessionId?: string;
};

/**
 * Describes the message forms.v1.GetPollStatsRequest.
 * Use `create(GetPollStatsRequestSchema)` to create a new message.
 */
export const GetPollStatsRequestSchema: GenMessage<GetPollStatsRequest, { jsonType: GetPollStatsRequestJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_poll, 24);

/**
 * @generated from message forms.v1.GetPollStatsResponse
 */
export type GetPollStatsResponse = Message<"forms.v1.GetPollStatsResponse"> & {
	/**
	 * per-question results (drives All Results / Final Results)
	 *
	 * @generated from field: repeated forms.v1.QuestionStats question_stats = 1;
	 */
	questionStats: QuestionStats[];
};

/**
 * @generated from message forms.v1.GetPollStatsResponse
 */
export type GetPollStatsResponseJson = {
	/**
	 * per-question results (drives All Results / Final Results)
	 *
	 * @generated from field: repeated forms.v1.QuestionStats question_stats = 1;
	 */
	questionStats?: QuestionStatsJson[];
};

/**
 * Describes the message forms.v1.GetPollStatsResponse.
 * Use `create(GetPollStatsResponseSchema)` to create a new message.
 */
export const GetPollStatsResponseSchema: GenMessage<GetPollStatsResponse, { jsonType: GetPollStatsResponseJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_poll, 25);

/**
 * @generated from message forms.v1.EndSessionResponse
 */
export type EndSessionResponse = Message<"forms.v1.EndSessionResponse"> & {
	/**
	 * @generated from field: repeated forms.v1.QuestionStats question_stats = 1;
	 */
	questionStats: QuestionStats[];

	/**
	 * @generated from field: repeated forms.v1.SessionAnswer answers = 2;
	 */
	answers: SessionAnswer[];
};

/**
 * @generated from message forms.v1.EndSessionResponse
 */
export type EndSessionResponseJson = {
	/**
	 * @generated from field: repeated forms.v1.QuestionStats question_stats = 1;
	 */
	questionStats?: QuestionStatsJson[];

	/**
	 * @generated from field: repeated forms.v1.SessionAnswer answers = 2;
	 */
	answers?: SessionAnswerJson[];
};

/**
 * Describes the message forms.v1.EndSessionResponse.
 * Use `create(EndSessionResponseSchema)` to create a new message.
 */
export const EndSessionResponseSchema: GenMessage<EndSessionResponse, { jsonType: EndSessionResponseJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_poll, 26);

/**
 * One voter session entry for the producer per-contact results table.
 *
 * @generated from message forms.v1.PollVoteRow
 */
export type PollVoteRow = Message<"forms.v1.PollVoteRow"> & {
	/**
	 * @generated from field: string submitter_id = 1;
	 */
	submitterId: string;

	/**
	 * @generated from field: string session_id = 2;
	 */
	sessionId: string;

	/**
	 * ACTIVE, COMPLETED, or CANCELLED
	 *
	 * @generated from field: string session_status = 3;
	 */
	sessionStatus: string;

	/**
	 * @generated from field: repeated forms.v1.SessionAnswer answers = 4;
	 */
	answers: SessionAnswer[];

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 5;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * @generated from field: optional google.protobuf.Timestamp completed_at = 6;
	 */
	completedAt?: Timestamp | undefined;
};

/**
 * One voter session entry for the producer per-contact results table.
 *
 * @generated from message forms.v1.PollVoteRow
 */
export type PollVoteRowJson = {
	/**
	 * @generated from field: string submitter_id = 1;
	 */
	submitterId?: string;

	/**
	 * @generated from field: string session_id = 2;
	 */
	sessionId?: string;

	/**
	 * ACTIVE, COMPLETED, or CANCELLED
	 *
	 * @generated from field: string session_status = 3;
	 */
	sessionStatus?: string;

	/**
	 * @generated from field: repeated forms.v1.SessionAnswer answers = 4;
	 */
	answers?: SessionAnswerJson[];

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 5;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: optional google.protobuf.Timestamp completed_at = 6;
	 */
	completedAt?: TimestampJson;
};

/**
 * Describes the message forms.v1.PollVoteRow.
 * Use `create(PollVoteRowSchema)` to create a new message.
 */
export const PollVoteRowSchema: GenMessage<PollVoteRow, { jsonType: PollVoteRowJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_poll, 27);

/**
 * @generated from message forms.v1.ListPollVotesRequest
 */
export type ListPollVotesRequest = Message<"forms.v1.ListPollVotesRequest"> & {
	/**
	 * @generated from field: string poll_id = 1;
	 */
	pollId: string;

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 2;
	 */
	pagination?: PaginationArguments | undefined;

	/**
	 * if set, only sessions that answered this question
	 *
	 * @generated from field: optional string question_id = 3;
	 */
	questionId?: string | undefined;

	/**
	 * @generated from field: optional string submitter_id = 4;
	 */
	submitterId?: string | undefined;
};

/**
 * @generated from message forms.v1.ListPollVotesRequest
 */
export type ListPollVotesRequestJson = {
	/**
	 * @generated from field: string poll_id = 1;
	 */
	pollId?: string;

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 2;
	 */
	pagination?: PaginationArgumentsJson;

	/**
	 * if set, only sessions that answered this question
	 *
	 * @generated from field: optional string question_id = 3;
	 */
	questionId?: string;

	/**
	 * @generated from field: optional string submitter_id = 4;
	 */
	submitterId?: string;
};

/**
 * Describes the message forms.v1.ListPollVotesRequest.
 * Use `create(ListPollVotesRequestSchema)` to create a new message.
 */
export const ListPollVotesRequestSchema: GenMessage<ListPollVotesRequest, { jsonType: ListPollVotesRequestJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_poll, 28);

/**
 * @generated from message forms.v1.ListPollVotesResponse
 */
export type ListPollVotesResponse = Message<"forms.v1.ListPollVotesResponse"> & {
	/**
	 * @generated from field: repeated forms.v1.PollVoteRow votes = 1;
	 */
	votes: PollVoteRow[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * @generated from message forms.v1.ListPollVotesResponse
 */
export type ListPollVotesResponseJson = {
	/**
	 * @generated from field: repeated forms.v1.PollVoteRow votes = 1;
	 */
	votes?: PollVoteRowJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message forms.v1.ListPollVotesResponse.
 * Use `create(ListPollVotesResponseSchema)` to create a new message.
 */
export const ListPollVotesResponseSchema: GenMessage<ListPollVotesResponse, { jsonType: ListPollVotesResponseJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_poll, 29);

/**
 * @generated from service forms.v1.PollService
 */
export const PollService: GenService<{
	/**
	 * @generated from rpc forms.v1.PollService.CreatePoll
	 */
	createPoll: {
		methodKind: "unary";
		input: typeof CreatePollRequestSchema;
		output: typeof CreatePollResponseSchema;
	};
	/**
	 * @generated from rpc forms.v1.PollService.GetPoll
	 */
	getPoll: {
		methodKind: "unary";
		input: typeof GetPollRequestSchema;
		output: typeof GetPollResponseSchema;
	};
	/**
	 * @generated from rpc forms.v1.PollService.UpdatePoll
	 */
	updatePoll: {
		methodKind: "unary";
		input: typeof UpdatePollRequestSchema;
		output: typeof UpdatePollResponseSchema;
	};
	/**
	 * @generated from rpc forms.v1.PollService.DeletePoll
	 */
	deletePoll: {
		methodKind: "unary";
		input: typeof DeletePollRequestSchema;
		output: typeof DeletePollResponseSchema;
	};
	/**
	 * @generated from rpc forms.v1.PollService.ListPolls
	 */
	listPolls: {
		methodKind: "unary";
		input: typeof ListPollsRequestSchema;
		output: typeof ListPollsResponseSchema;
	};
	/**
	 * @generated from rpc forms.v1.PollService.ListPollVotes
	 */
	listPollVotes: {
		methodKind: "unary";
		input: typeof ListPollVotesRequestSchema;
		output: typeof ListPollVotesResponseSchema;
	};
	/**
	 * @generated from rpc forms.v1.PollService.SubmitPollAnswer
	 */
	submitPollAnswer: {
		methodKind: "unary";
		input: typeof SubmitPollAnswerRequestSchema;
		output: typeof SubmitPollAnswerResponseSchema;
	};
	/**
	 * @generated from rpc forms.v1.PollService.GetQuestionStats
	 */
	getQuestionStats: {
		methodKind: "unary";
		input: typeof GetQuestionStatsRequestSchema;
		output: typeof GetQuestionStatsResponseSchema;
	};
	/**
	 * @generated from rpc forms.v1.PollService.GetPollStats
	 */
	getPollStats: {
		methodKind: "unary";
		input: typeof GetPollStatsRequestSchema;
		output: typeof GetPollStatsResponseSchema;
	};
}> = /*@__PURE__*/ serviceDesc(file_forms_v1_poll, 0);
